<template>
<b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
  <div class="ct-quote">
    <nav-bar />
    <b-container fluid>
      <div class="main-panel">
        <div class="db-content-wrapper">
          <!-- <b-row class="pb-3 mt-4">
            <b-col>
              <h4 class="page-title">
                {{ workOrder ? "Work Orders" : "Quotes" }}
              </h4>
            </b-col>
          </b-row> -->

          <div class="filter mt-4 pb-3" :style="workOrder ? 'display: flex;flex-wrap: wrap':'flex-wrap: wrap;'">
              <h4 class="page-title">
                {{ workOrder ? "Work Orders" : "Quotes" }}
              </h4>

              <!-- Filters in quote listing page -->
              <div class="ct-filter" v-if="!workOrder">
                <div class="ct-filter-text d-flex mb-2">
                    <router-link
                  :to="{
                    name: 'contractor-quote',
                    query: { quoteType: 'my-quotes' },
                  }"
                  :style="{ color: 'grey', padding: '5px' }"
                >
                  <h5 style="display: inline; font-weight: bold">My Quotes</h5>
                </router-link>
                <router-link
                  :to="{
                    name: 'contractor-quote',
                    query: { quoteType: 'public-quotes' },
                  }"
                  :style="{ color: 'grey', padding: '5px' }"
                >
                  <h5 style="display: inline">/ Discover Quotes (Public Quotes)</h5>
                </router-link>
                </div>
                <div class="ct-filter-div">
                    <div class="datagrid-header">
                        <b-form @submit.prevent inline>
                            <div style="text-align: right" class="quotes-control">
                            <treeselect
                                class="mb-2 mr-sm-2 mb-sm-0 quotes-control-cname"
                                :multiple="false"
                                :options="companyOption"
                                placeholder="Choose Manager..."
                                v-model="filterCompany"
                                @input="filter(1)"
                            />

                            <label class="sr-only" for="quoteStatus">Status</label>
                            <b-form-select
                                v-model="filterStatus"
                                class="mb-2 mr-sm-2 mb-sm-0 quotes-control-select"
                                id="quoteStatus"
                                :options="[
                                { value: 'all', text: 'All' },
                                {
                                    value: 'contractor-dashboard-active-tender-quotes',
                                    text: 'Active Tenders',
                                },
                                {
                                    value: 'contractor-dashboard-active-quotes',
                                    text: 'Active Quotes',
                                },
                                {
                                    value: 'contractor-dashboard-pending-approval-quotes',
                                    text: 'Pending Approval',
                                },
                                { value: 'due-soon', text: 'Due Soon' },
                                { value: 'overdue', text: 'Over Due' },
                                ]"
                                @change="filter(1)"
                            ></b-form-select>
                            <b-form-input
                                class="mb-2 mb-sm-0 quotes-control-search"
                                placeholder="Search"
                                v-model="filterQuery"
                                @change="filter(1)"
                            ></b-form-input>
                            </div>
                        </b-form>
                    </div>
                </div>
              </div>

              <!-- Filter in workorder listing page -->
              <div class="ct-filter" v-if="workOrder">
                <div class="ct-filter-div">
                    <div class="datagrid-header">
                        <b-form @submit.prevent inline>
                            <div style="text-align: right" class="quotes-control">
                            <treeselect
                                class="mb-2 mr-sm-2 mb-sm-0 quotes-control-cname"
                                :multiple="false"
                                :options="companyOption"
                                placeholder="Choose Manager..."
                                v-model="filterCompany"
                                @input="filter(1)"
                            />

                            <label class="sr-only" for="quoteStatus">Status</label>
                            <b-form-select
                                v-model="filterStatus"
                                class="mb-2 mr-sm-2 mb-sm-0 quotes-control-select"
                                id="quoteStatus"
                                :options="workOrderStatusOptions"
                                @change="filter(1)"
                            ></b-form-select>
                            <b-form-input
                                class="mb-2 mb-sm-0 quotes-control-search"
                                placeholder="Search"
                                v-model="filterQuery"
                                @change="filter(1)"
                            ></b-form-input>
                            </div>
                        </b-form>
                    </div>
                </div>
              </div>
          </div>


          <div class="datagrid my-4">
            <div class="datagrid-body mb-5">
              <b-table
                :busy="this.$root.loading"
                :items="this.workOrder ? workOrderTableItems : tableItems"
                :fields="this.workOrder ? workOrderTableFields : tableFields"
                :current-page="currentPage"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                sort-icon-left
                hover
                responsive
                show-empty
              >
                <template v-slot:cell(status)="row">
                  <div v-if="workOrder">
                    <p
                      v-if="row.item.status == 'open'"
                      style="
                        background-color: rgb(137 206 61);
                        display: inline-block;
                        padding: 3px 6px;
                        font-size: 12px;
                        color: white;
                      "
                    >
                      Open
                    </p>
                    <p
                      v-if="row.item.status == 'draft'"
                      style="
                        background-color: rgb(216 195 43);
                        display: inline-block;
                        padding: 3px 6px;
                        font-size: 12px;
                        color: white;
                      "
                    >
                      Draft
                    </p>
                    <p
                      v-if="row.item.status == 'granted'"
                      style="
                        display: inline-block;
                        font-size: 12px;
                        color: #F2994A;
                      "
                    >
                      Awarded
                    </p>
                    <p
                      v-if="row.item.status == 'in-progress'"
                      style="
                        color: #00AB54;
                        display: inline-block;
                        font-size: 12px;
                      "
                    >
                      In Progress
                    </p>
                      <p
                      v-if="row.item.status == 'verify-completed'"
                      style="
                        color: rgb(15 132 215);
                        display: inline-block;
                        font-size: 12px;
                      "
                    >
                     Awaiting Verfication
                    </p>
                      <p
                      v-if="row.item.status == 'completed'"
                      style="
                        color: #00AB54;
                        display: inline-block;
                        font-size: 12px;
                      "
                    >
                     Completed
                    </p>
                    <p
                      v-if="row.item.status == 'cancelled'"
                      style="
                        background-color: rgb(235, 87, 87);
                        display: inline-block;
                        padding: 3px 6px;
                        font-size: 12px;
                        color: white;
                      "
                    >
                      Cancelled
                    </p>
                  </div>
                  <div v-if="!workOrder">
                    <p
                      v-if="row.item.status == 'open'"
                      style="
                        display: inline-block;
                        font-size: 14px;
                        color: #00ba88;
                      "
                    >
                      Open
                    </p>
                    <p
                      v-if="row.item.status == 'active'"
                       style="
                        display: inline-block;
                        font-size: 14px;
                        color: #4682b4;
                      "
                    >
                      Active
                    </p>
                    <!-- active-due-quotes -->
                    <p
                      v-if="row.item.status == 'active-due-quotes'"
                      style="
                        display: inline-block;
                        font-size: 14px;
                        color: #4682b4;
                      "
                    >
                      Active
                      {{
                        row.item.remaningdays == 1
                          ? "( Expiring in " + row.item.remaningdays + " day )"
                          : row.item.remaningdays > 1
                          ? "( Expiring in " + row.item.remaningdays + " days )"
                          : "(Expiring Today)"
                      }}
                    </p>
                    <p
                      v-if="row.item.status == 'pending-approval'"
                      style="
                        display: inline-block;
                        font-size: 14px;
                        color: rgb(195 18 227 / 78%);
                      "
                    >
                      Pending Approval
                    </p>

                    <!-- For Open due quotes -->
                    <p
                      v-if="row.item.status == 'open-due-quotes'"
                      style="
                        display: inline-block;
                        font-size: 14px;
                        color: #00ba88;
                      "
                    >
                      Open
                      {{
                        row.item.remaningdays == 1
                          ? "( Expiring in " + row.item.remaningdays + " day )"
                          : row.item.remaningdays > 1
                          ? "( Expiring in " + row.item.remaningdays + " days )"
                          : "(Expiring Today)"
                      }}
                    </p>
                    <p
                      v-if="row.item.status == 'over-due'"
                      style="
                        display: inline-block;
                        padding: 3px 6px;
                        font-size: 14px;
                        color: rgb(233 22 22);
                      "
                    >
                      Overdue
                      {{ "(" + row.item.remaningdays + " Days Passed)" }}
                    </p>
                    <p
                      v-if="row.item.status == 'draft'"
                      style="
                        background-color: rgb(216 195 43);
                        display: inline-block;
                        padding: 3px 6px;
                        font-size: 12px;
                        color: white;
                      "
                    >
                      Draft
                    </p>
                    <p
                      v-if="row.item.status == 'completed'"
                      style="
                        background-color: rgb(207 14 201);
                        display: inline-block;
                        padding: 3px 6px;
                        font-size: 12px;
                        color: white;
                      "
                    >
                      Completed
                    </p>
                  </div>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner
                      class="align-middle"
                      :variant="'primary'"
                    ></b-spinner>
                  </div>
                </template>

                <template v-slot:cell(progress)="row">
                  <b-progress
                    v-if="row.item.status == 'in-progress' || row.item.status == 'verify-completed'"
                    :value="row.item.progress_percentage"
                    variant="success"
                    striped
                    :animated="animate"
                    :style="{ background: '#afffa5' }"
                  ></b-progress>
                  <b-progress
                    v-if="row.item.status == 'granted'"
                    :value="row.item.progress_percentage"
                    variant="warning0128"
                    striped
                    :animated="animate"
                    :style="{ background: '#F2994A' }"
                  ></b-progress>
                  <b-progress
                    v-if="row.item.status == 'completed'"
                    :value="row.item.progress_percentage"
                    variant="success"
                    striped
                    :animated="animate"
                    :style="{ background: '#afffa5' }"
                  ></b-progress>
                  <b-progress
                    v-if="row.item.status == 'cancelled'"
                    variant="danger"
                    striped
                    :animated="animate"
                    :style="{ background: '#EB5757 ' }"
                  ></b-progress>
                </template>

                <template v-slot:cell(action)="row">
                  <router-link
                    v-if="workOrder"
                    :to="{
                      name: 'contractor-workorder-view',
                      params: { id: row.item.id },
                    }"
                    >View
                  </router-link>
                  <router-link
                    v-else
                    :to="{
                      name: 'contractor-quote-view',
                      params: { id: row.item.id },
                    }"
                    >View
                  </router-link>
                </template>
                <template #empty class="text-center"> No Data Found </template>
              </b-table>
            </div>
            <div class="datagrid-footer" v-if="lastPage > 1">
              <b-pagination
                pills
                align="right"
                :total-rows="total"
                v-model="currentPage"
                :page-count="lastPage"
                :per-page="perPage"
                hide-goto-end-buttons="true"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>

      <footer-component></footer-component>
    </b-container>
  </div>
  </b-overlay>
</template>

<script>
import NavBar from "../includes/NavBar.vue";
import _ from "lodash";
import moment from "moment";
import FooterComponent from "../../includes/FooterComponent.vue";
import { Treeselect, ASYNC_SEARCH } from "@riophae/vue-treeselect";

export default {
  components: {
    Treeselect,
    NavBar,
    FooterComponent,
  },
  props: {
    quoteType: String,
    workOrder: String,
  },
  data() {
    return {
      currentPage: 1,
      lastPage: 1,
      total: 0,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      perPage: 50,
      tableItems: [],
      tableFields: [
        { key: "date", sortable: true , label: 'Creation Date'},
        { key: "job_ID", sortable: true },
        { key: "due_date", sortable: true },
        { key: "strata_plan_ID", sortable: true },
        { key: "manager", sortable: true },
        { key: "library", sortable: true },
        { key: "status", sortable: true },
        { key: "action", sortable: false },
      ],
      workOrderTableItems: [],
      workOrderTableFields: [
        { key: "date", sortable: true, label: 'Creation Date'},
        { key: "job_ID", sortable: true },
        { key: "company", sortable: true },
        { key: "strata_plan_ID", sortable: true },
        { key: "progress", sortable: true },
        { key: "status", sortable: true },
        { key: "due_date", sortable: true },
        { key: "action", sortable: false },
      ],
      workOrderStatusOptions: [
        { value: 'all', text: 'All' },
        { value: 'contractor-awarded-workorders', text: 'Awarded' },
        { value: 'contractor-inprogress-workorders', text: 'In Progress' },
        { value: 'contractor-awaiting-verification-workorders', text: 'Awaiting Verfication' },
        { value: 'contractor-completed-workorders', text: 'Completed' },
        { value: 'contractor-cancelled-workorders', text: 'Cancelled' },
        { value: 'contractor-hold-workorders', text: 'Hold'}
      ],
      filterQuery: "",
      companyOption: [],
      filterCompany: "all",
      filterStatus: "all",
    };
  },
  mounted() {
    this.filter(1);
    this.loadCompanies();
  },
  methods: {
    filter(page = 1) {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/contractor/quote/filter", {
          load_media: true,
          load_strata_plan: true,
          load_manager: true,
          page: page,
          per_page: 20,
          filter_query: this.filterQuery,
          filter_status: this.filterStatus,
          filter_company_id: this.filterCompany,
          quote_type: this.quoteType,
          jobType: this.workOrder ? "work-order" : "quote",
        })
        .then((response) => {
          this.currentPage = response.data.current_page;
          this.total = response.data.total;
          this.perPage = response.data.per_page;
          this.lastPage = response.data.last_page;
          console.log(this.workOrder,"WORKD ORDER");

          if (this.workOrder) {
            this.workOrderTableItems = _.map(
              response.data.quotes,
              function (quote) {
                if (
                  quote.status_parsed == "active-due-quotes" ||
                  quote.status_parsed == "open-due-quotes"
                ) {
                  var dueDate = moment(quote.due_date).add(1, "days");
                  var currentDate = moment();
                  var subtractDate = dueDate.diff(currentDate, "days"); // 1
                }

                if (quote.status_parsed == "over-due") {
                  var dueDate = moment(quote.due_date);
                  var currentDate = moment();
                  var subtractDate = currentDate.diff(dueDate, "days"); // 1
                }

                return {
                  id: quote.id,
                  progress_percentage: quote.progress_percentage,
                  remaningdays: subtractDate ? subtractDate : "",
                  date: moment(quote.created_at).format("D MMM YYYY"),
                  job_ID: quote.organization_id,
                  company: quote.business.company_name,
                  strata_plan_ID: quote.strata_plan.type + '-' + quote.strata_plan.strata_plan_number,
                  progress: "Progress",
                  status: quote.status_parsed,
                  due_date: quote.due_date
                    ? moment(quote.due_date).format("D MMM YYYY")
                    : null,
                  action: "",
                };
              }
            );
          } else {
              this.tableItems = _.map(response.data.quotes, (quote) => {
              if (
                quote.status_parsed == "active-due-quotes" ||
                quote.status_parsed == "open-due-quotes"
              ) {
                var dueDate = moment(quote.due_date).add(1, "days");
                var currentDate = moment();
                var subtractDate = dueDate.diff(currentDate, "days"); // 1
              }

              if (quote.status_parsed == "over-due") {
                var dueDate = moment(quote.due_date);
                var currentDate = moment();
                var subtractDate = currentDate.diff(dueDate, "days"); // 1
              }

              return {
                id: quote.id,
                remaningdays: subtractDate ? subtractDate : 0,
                date: moment(quote.created_at).format("D MMM YYYY"),
                job_ID: quote.organization_id,
                due_date: quote.due_date
                  ? moment(quote.due_date).format("D MMM YYYY")
                  : null,
                strata_plan_ID: quote.strata_plan.type + '-' + quote.strata_plan.strata_plan_number,
                manager:
                quote.manager.first_name + " " + quote.manager.last_name,
                library: "Documents (" + (quote.media?.length || 0) + ")",
                status: quote.status_parsed,
                action: "",
              };
            });
          }
          this.$root.$data.bsLoader = false;
        }).catch((err) => {
          this.$root.$data.bsLoader = false;
        });
    },
    loadCompanies() {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/content/getCompanies", {
          quote_type: this.quoteType,
          jobType: this.workOrder ? "work-order" : "quote",
        })
        .then((response) => {
          this.companyOption = response.data.companies.map((company) => {
            return {
              id: company.id,
              label: company.company_name,
            };
          });

          // //Adding all option at the beginnning of select option
          this.companyOption.unshift({
            id: "all",
            label: "Company",
          });
          this.$root.$data.bsLoader = false;
        }).catch((err) => {
          this.$root.$data.bsLoader = false;
        });
    },
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.filter(value);
      },
    },
    $route($to, $from) {
      if (
        $to.query.quoteType == "my-quotes" ||
        $to.query.quoteType == "public-quotes"
      ) {
        this.filter(1);
        this.loadCompanies();
      }
      if (
        $to.name == "contractor-quote" ||
        $to.name == "contractor-workorder"
      ) {
        this.filter(1);
        this.loadCompanies();
      }
    },
  },
};
</script>

<style scoped>
.datagrid-header {
    padding: 0;
}

.quotes-control {
  display: flex;
  gap: 0.85rem;
  flex-wrap: wrap;
}

@media screen and (min-width: 1300px) {
    .quotes-control {
        /* width: 50%; */
        margin-left: auto;
    }
}

@media screen and (min-width: 576px) {
  .quotes-control-cname,
  .quotes-control-select,
  .quotes-control-search {
    flex: 1;
  }
}

@media screen and (min-width: 992px) {
    .ct-filter {
        display: flex;
        align-items: center;
        flex: 2;
    }

    .ct-filter-text,
    .ct-filter-div {
        flex: 1;
    }
}

.filter {
  /* display: flex;
  flex-wrap: wrap; */
}

.filter h4.page-title {
  flex: 1;
}

</style>
